import React, { Component } from "react";
import Action from "../../components/Action";
import Card from "../../components/Card";
import RadioQuestion from "../../components/RadioQuestion";
import { TextareaQuestion } from "../../components/TextQuestion";
import List, { ListItem } from "../../components/List";
import ScrollToTop from "../../components/utils/ScrollToTop";
import Image from "../../components/Image";
import imageCatAndHousePlant from "../../images/cat-and-houseplant.png";
import { leadSourceReferrer } from "./leadSourceReferrer";

const clientReferrerOptions = [
  {
    title: "Recommendation from a friend or colleague",
    value: "Friend or colleague",
  },
  {
    title: "Recommendation from an estate agent",
    value: "Estate agent",
  },
  {
    title: "Recommendation from a mortgage broker",
    value: "Mortgage broker",
  },
  {
    title: "Found the Juno website in a Google search",
    value: "Google search",
  },
  {
    title: "Found Juno through AI (ChatGPT, Claude, Gemini)",
    value: "AI assistant",
  },
  {
    title: "Found the Juno website from Trustpilot",
    value: "Trustpilot",
  },
  {
    title: "Found the Juno website from social media",
    value: "Social media",
  },
];

class AnythingElse extends Component {
  constructor(props) {
    super(props);
    // A referred lead's source already says how they heard about us.
    this.sourceReferrer = leadSourceReferrer(props.leadSource);

    if (this.props.anythingElse) {
      const details = this.props.anythingElse;
      this.state = {
        anythingElse: details.anythingElse,
        clientReferrer: details.clientReferrer,
        errors: {},
      };
    } else {
      this.state = {
        anythingElse: "",
        clientReferrer: "",
        errors: {},
      };
    }
  }

  handleValidation() {
    const fields = { ...this.state };

    let errors = {};
    let formIsValid = true;

    if (!this.sourceReferrer && !fields["clientReferrer"]) {
      const field = "clientReferrer";
      formIsValid = false;
      errors[field] = true;
    }

    this.setState({ errors });
    return formIsValid;
  }

  handleFieldValidation = (field) => (event) => {
    const isBlur = event.type === "blur";
    this.setState((prevState) => {
      let errors = { ...prevState.errors };

      if (!isBlur) {
        // Hide the error when you interact with the field
        errors[field] = null;
      } else {
        // If the state for this field hasn't been set, we need some input, show an error
        if (!prevState[field]) {
          errors[field] = true;
        }
      }

      return { errors };
    });
  };

  anythingElseEntered = (ae) => {
    this.setState({ anythingElse: ae });
  };

  selectClientReferrer = (cr) => {
    this.setState({ clientReferrer: cr });
  };

  saveAnythingElse = (event) => {
    event.preventDefault();

    if (this.handleValidation()) {
      this.props.onStepComplete({
        anythingElse: {
          anythingElse: this.state.anythingElse,
          clientReferrer: this.sourceReferrer ?? this.state.clientReferrer,
        },
      });
      return;
    }
  };

  render() {
    const transactionType = this.props.transactionType;

    let tt;
    if (transactionType === "Selling") {
      tt = "sale";
    } else if (transactionType === "Buying") {
      tt = "purchase";
    } else if (transactionType === "BuyingAndSelling") {
      tt = "sale and purchase";
    }

    return (
      <React.Fragment>
        <ScrollToTop />
        <Card title="Is there anything else you’d like to tell us?" removeTopPadding>
          <React.Fragment>
            <p>For example,</p>
            <List bullet>
              <ListItem>Would you like to complete before or after a particular date?</ListItem>
              <ListItem>Has the property undergone any major renovations?</ListItem>
              <ListItem>Does the property have any unusual features?</ListItem>
              <ListItem>Is it currently rented out?</ListItem>
              <ListItem>Are there any works ongoing at the property?</ListItem>
              <ListItem>
                Are there any personal circumstances, for example divorce, that would affect your {tt}?
              </ListItem>
              <ListItem>Do you have any other special requirements?</ListItem>
            </List>
          </React.Fragment>

          <TextareaQuestion
            question="Anything else?"
            optional={true}
            value={this.state.anythingElse}
            valueEntered={this.anythingElseEntered}
          />

          {!this.sourceReferrer && (
            <RadioQuestion
              question="How did you hear about Juno?"
              options={clientReferrerOptions}
              inline={false}
              name="clientReferrer"
              selected={this.state.clientReferrer}
              optionSelected={this.selectClientReferrer}
              validate={this.handleFieldValidation("clientReferrer")}
              validationError={this.state.errors.clientReferrer ? "Let us know how you found out about Juno" : null}
            />
          )}

          <Action onClick={this.saveAnythingElse}>Continue</Action>
        </Card>
        <Image src={imageCatAndHousePlant} />
      </React.Fragment>
    );
  }
}

export default AnythingElse;
